module.exports = __webpack_public_path__ + "static/media/arrow_down.1c9f9d8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/arrow_down.svg
// module id = 484
// module chunks = 0